import { App } from 'vue'
import stringInd from '@/data/local/json/stringind.json'

export default {
  install: (app: App<Element>) => {
    const vue = app
    vue.config.globalProperties.$strInd = stringInd
  }
}
